// Create a context for '_themeBase.js' files in subdirectories
const requireThemeBases = require.context(
  '.',                      // Start at the current directory (Themes)
  true,                     // Include subdirectories
  /^\.\/[^/]+\/_themeBase\.js$/ // Match '_themeBase.js' files in subdirectories
);

const themeBases = {};

requireThemeBases.keys().forEach((filePath) => {
  // filePath examples:
  // './Black Friday/_themeBase.js'
  // './Monochrome/_themeBase.js'

  // Exclude WIP themes
  if (filePath.startsWith('./_') || filePath.startsWith('./_')) {
    return;
  }

  // Extract the theme name from the file path
  const pathParts = filePath.split('/');
  if (pathParts.length !== 3) {
    return;
  }

  const themeName = pathParts[1]; // e.g., 'Black Friday'

  // Import the module
  const module = requireThemeBases(filePath);

  // Ensure the module exports both the theme and the main colors
  const theme = module.default || module;
  if (!theme || !theme.theme || !theme.mainColors) {
    console.warn(`Theme '${themeName}' does not properly export 'theme' and 'mainColors'.`);
    return;
  }

  // Add the theme and its main colors to the themeBases object
  themeBases[themeName] = {
    theme: theme.theme,          // The full theme object
    mainColors: theme.mainColors // The main colors object
  };
});

export default themeBases;
